<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Link Alternate Printable
            </template>

            <div class="row align-items-center">
                <div class="col-lg-12 order-lg-1 order-2">
                    <b-form-group
                        class="mt-3"
                        label="Select Alternate Printable Language"
                    >
                        <language-multiselect
                            v-model="selected_language"
                            :options="alternateLanguageOptions"
                            :multiple="false"
                            @add="addLanguage"
                            @remove="removeLanguage"
                        />
                        <b-form-invalid-feedback :state="!selected_language ? false : null">
                            Language is required before being able to select alternate printable
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                        class="mt-3"
                        label="Select Alternate Printable"
                    >
                        <div v-if="alternate_printables_options_loading">
                            <b-spinner label="Options Loading...">Options Loading...</b-spinner>
                        </div>
                        <multiselect
                            v-else
                            :disabled="!selected_language"
                            v-model="new_language_printable"
                            :options="filteredAlternatePrintablesOptions"
                            label="id"
                            :custom-label="formattedLabel"
                            track-by="id"
                        >
                            <template #option="{ option }">
                                <div>
                                    <flag :iso="getFlagIso(option.language)" /> {{ option.id }} - {{ option.title }}
                                </div>
                            </template>
                            <template #singleLabel="{ option }">
                                <span class="d-flex align-items-center">
                                    <div>
                                        <flag :iso="getFlagIso(option.language)" /> {{ option.id }} - {{ option.title }}
                                    </div>
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <template #modal-footer>
                <div v-if="!adding_media">
                    <b-button
                        variant="primary"
                        @click="linkAlternatePrintable"
                        :disabled="validating()"
                    >
                        Link Alternate Media
                    </b-button>
                </div>
                <div v-else>
                    <b-spinner small label="Linking..."></b-spinner>
                    - Linking Alternate Media 
                </div>
                <b-button
                    variant="light"
                    @click="cancel"
                    :disabled="adding_media"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

import LanguageMultiselect from '@/components/LanguageMultiselect'

import languages from '@/common/languages'

export default {
    data: () => ({
        new_language_printable: null,
        selected_language: null,
        languages: languages,
        adding_media: false
    }),
    props: [
        'alternate_printables_options',
        'alternate_printables_options_loading',
        'printable_to_link',
        'printable_group',
        'value'
    ],
    components: {
        LanguageMultiselect
    },
    computed: {
        ...mapState({
        }),
        modal_id () {
            let modal_id = 'add-alternate-media-modal'
            return modal_id
        },
        alternateLanguageOptions() {
            return this.languages.filter(lang => lang.language !== this.printable_to_link.language);
        },
        filteredAlternatePrintablesOptions() {
            const printable_group_ids = this.printable_group.map(printable => printable.id);
            if (!this.selected_language) {
                return this.alternate_printables_options
            }
            if (this.alternate_printables_options.length > 0) {
                return this.alternate_printables_options.filter(printable => {

                    let language_match = printable.language === this.selected_language.language;
                    let not_in_printable_group = !_.includes(printable_group_ids, printable.id);

                    return language_match && not_in_printable_group
                })
            }
            return [];
        }
    },
    watch: {
        'printable_to_link.id': {
            handler(value) {
                // mark to remove once we have more than two languages
                this.setStartingSelectedLanguage();
            }
        },
    },
    methods: {
        validating(){
            if (!this.new_language_printable) {
                return true;
            }
            const { id } = this.new_language_printable;

            return !(this.selected_language && id);
        },
        addLanguage(new_language){
            this.selected_language = new_language;
        },
        removeLanguage(){
            this.selected_language = null;
            this.new_language_printable = null;
        },
        cancel (event) {
            event.preventDefault()
            this.new_language_printable = null
            this.hide()
        },
        hide () {
            this.$emit('hideAddAlternate')
        },
        hidden () {
            this.$emit('hideAddAlternate')
        },
        formattedLabel (option) {
            return `${option.id} - ${option.title}`
        },
        getFlagIso (language) {
            const languageObject = this.languages.find(lang => lang.language === language)
            return languageObject ? languageObject.flag_iso : null
        },
        findPrintablesByLanguage(printablesArray, language) {
            return printablesArray.find(printable => printable.language === language);
        },
        getLanguageLabel(language) {
            const languageObject = this.languages.find(lang => lang.language === language);
            return languageObject ? languageObject.label : null;
        },
        linkPrintableToGroup() {
            this.axios.post('/api/media/link_printable_to_group/'+this.printable_to_link.id+'/'+this.new_language_printable.id+'/'+this.new_language_printable.group_id)
                .then(response => {
                    if(!response){
                        this.$bvToast.toast('An error has ocurred', {
                            title: 'Error',
                            variant: 'danger',
                            solid: false,
                            autoHideDelay: 3000,
                            appendToast: true
                        })
                    }
                    else{
                        this.$bvToast.toast('Media was successfully linked', {
                            title: 'Success',
                            variant: 'success',
                            solid: false,
                            autoHideDelay: 3000,
                            appendToast: true
                        })
                    }
                    this.$emit('alternateAdded');
                    this.new_language_printable = null
                    this.hide()
                    
                })
        },
        linkAlternatePrintable() {
            const linkedPrintable = this.findPrintablesByLanguage(this.printable_group, this.new_language_printable.language);
            if (linkedPrintable) {
                let message = `
                    <h4>Selected Printable already has ${this.getLanguageLabel(this.new_language_printable.language)} Printable linked</h4>
                    </br>
                    <p><strong>${this.printable_to_link.id} - ${this.printable_to_link.title} (${this.printable_to_link.language})</strong> 
                    is already linked to <strong>${linkedPrintable.id} - ${linkedPrintable.title} (${linkedPrintable.language})</strong>. Do you want to continue and replace this printable with the 
                    new selected ${this.getLanguageLabel(this.new_language_printable.language)} language printable <strong>${this.new_language_printable.id} - ${this.new_language_printable.title}</strong>?</p>
                `
                this.$swal({
                    html: message,
                    showCancelButton: true,
                    confirmButtonText: 'Link to new Printable',
                    confirmButtonColor: '#27AE60',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {               
                        this.linkPrintableToGroup()
                    }
                })
            } else {
                this.linkPrintableToGroup()
            }
        },
        setStartingSelectedLanguage() {
            // This function just sets the selected language based on the printable_to_link language and is only needed while we have two languages (en & es)
            // once more languages are added we don't need to do this check, as you will want select beteween multiple languages in the select language dropdown
            if (this.printable_to_link.language === 'es') {
                this.selected_language = {
                    language: 'en',
                    label: 'English',
                    flag_iso: 'us'
            }
            } else if (this.printable_to_link.language === 'en') {
                this.selected_language = {
                    language: 'es',
                    label: 'Spanish',
                    flag_iso: 'es'
                }
            }
        },
        
    },
    mounted () {
        // mark to remove once we have more than two languages
        this.setStartingSelectedLanguage();
           
    },
    
}

</script>
